module.exports = __webpack_public_path__ + "static/media/xo-phao.857627b7.png";